// extracted by mini-css-extract-plugin
export default {"modal":"AreYouSureModal_modal__lNlMY","modalContent":"AreYouSureModal_modalContent__WSgLj","icon":"AreYouSureModal_icon__wf2V3","text":"AreYouSureModal_text__mvYLH"};